import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";
import { projectRoleState } from "src/recoil/atoms/global";
import { authState } from "src/recoil/atoms/auth";
import { ROLES } from "src/constant/common";
import TooltipWrapper from "src/components/Common/TooltipWrapper";

const ProtectedComponent = ({ children, requiredRole = ROLES.EDITOR, id, ownerId = null }) => {
  const { t } = useTranslation("common");
  const auth = useRecoilValue(authState);
  const role = useRecoilValue(projectRoleState);
  const [passPermission, setPassPermission] = useState(false);

  useEffect(() => {
    if (role && auth?.id) {
      const isOwner = parseInt(ownerId) === auth.id;
      if ((role === requiredRole && (ownerId ? isOwner : true)) || role === ROLES.ADMIN || role === ROLES.SERVICE_ADMIN) {
        setPassPermission(true);
      } else {
        setPassPermission(false);
      }
    }
  }, [role, requiredRole, auth, ownerId]);

  return passPermission ? (
    <>{children}</>
  ) : (
    <TooltipWrapper
      tooltipText={t("non_permission")}
      id={`permission-${requiredRole}-${id}`}
      tooltipClassName="max-width-by-px-300"
    >
      <div className="fit-content">
        <div className="no-permission">{children}</div>
      </div>
    </TooltipWrapper>
  )
};

export default ProtectedComponent;
